import React from 'react';

import Button from "./Button";
import Flex from "./Flex";
import GenericSearchResult from "./GenericSearchResult";
import earth2 from "../../assets/images/icons/earth2.svg";

const CitySearchResults = props => {
  return (
    <div>
      {
        props.cities.map(city => {
          return (
            <GenericSearchResult key={city.id}>
              <Flex>
                <div style={{marginRight:"10px"}}>
                  <img src={earth2} alt={`Earth`} style={{width:"24px"}} />
                </div>
                <div>
                  {city.name}, {city.countrycode}<br />
                  <small>{city.latitude},{city.longitude}</small>
                </div>
              </Flex>
              <div>
                <Button onClick={() => props.updateLocation(city.latitude, city.longitude)}>
                  Set model to this location
                </Button>
              </div>
            </GenericSearchResult>
          )
        })
      }
    </div>
  )
};

export default CitySearchResults;
